import React from "react";
//outsource
import { DatePicker } from "antd";

const formatDate = "DD/MM/YYYY";

const TimeTo = (props) => {
  // -------------------------- VAR --------------------------
  const { from } = props;
  const { to, setTo } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (value) => {
    setTo(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      defaultValue={to}
      disabledDate={(current) => {
        return current && current < from;
      }}
      style={{ width: "100%" }}
      placeholder="To Date"
      format={formatDate}
      disabled={false}
      onChange={(value) => handleChange(value)}
      allowClear={false}
    />
  );
};

export default TimeTo;
